import { faCrown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import Media from '../../Components/Media';
import { ArticleAttribute } from '../../Types/ArticleAttribute';

interface AttributeCardProps {
  attribute: ArticleAttribute;
  isSelected?: boolean;
  className?: string;
}

const AttributeCard: React.FC<AttributeCardProps> = ({
  attribute,
  className = '',
  isSelected = false,
}) => {
  const [isHovering, setIsHovering] = useState(false);

  // Avoid card remaining active when deselected
  useEffect(() => {
    setIsHovering(false);
  }, [isSelected]);

  return (
    <div
      className={`
        flex flex-col justify-center w-full text-sm rounded-xl bg-gray-50 border border-gray-200 cursor-pointer
        ${className}
      `}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      <div
        className={`flex overflow-hidden relative flex-col w-full h-[180px]`}
      >
        {attribute.image ? (
          <div
            className={`absolute inset-0 bg-gray-100 rounded-xl overflow-hidden`}
          >
            <Media
              src={[
                attribute.image.thumbnailUrl,
                attribute.image.compressedUrl,
                attribute.image.originalUrl,
                attribute.image.sharedStorageUrl,
              ]}
              alt={attribute.title}
              isActive={isSelected || isHovering}
              className={`object-cover absolute inset-0 rounded-xl !h-full !w-[120%]`}
            />
          </div>
        ) : (
          <div
            className={`flex absolute px-2 py-2 tracking-wide text-start text-gray-500 text-ellipsis italic`}
          >
            <div>Hang tight! Image is coming soon...</div>
          </div>
        )}

        {!isSelected && (
          <div
            className={`absolute top-0 bottom-0 left-0 right-0 rounded-xl z-[1] border-4 border-[#eebf17] border-b-8`}
          />
        )}

        <div
          className={`absolute flex flex-col top-0 left-0 w-full h-full ${
            !attribute.image
              ? 'text-gray-800'
              : 'bg-gradient-to-t from-black via-black-500/25 to-transparent text-white'
          } rounded-xl`}
          style={{
            backgroundSize: '100% 80%',
            backgroundPosition: 'bottom',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <div className={`px-3 pb-2 mt-auto`}>
            <div
              className={`relative mb-auto text-left text-base font-medium flex items-end gap-2`}
            >
              {attribute.title}
              <FontAwesomeIcon
                icon={faCrown}
                className="text-yellow-400 mb-1"
              />
            </div>
            {/* {attribute.description && (
              <div className="text-sm text-gray-300 text-left line-clamp-2 mt-1">
                {attribute.description}
              </div>
            )} */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttributeCard;
